
export enum ChartAnnotationMarkerTypesEnum {
    FREEHAND_MARKER = 'FreehandMarker',
    LINE_MARKER = 'LineMarker',
    ARROW_MARKER = 'ArrowMarker',
    CURVE_MARKER = 'CurveMarker',
    FRAME_MARKER = 'FrameMarker',
    HIGHLIGHT_MARKER = 'HighlightMarker',
    ELLIPSE_MARKER = 'EllipseMarker',
    TEXT_MARKER = 'TextMarker',
    CALLOUT_MARKER = 'CalloutMarker'
};

export enum ChartAnnotationMarkerStyleTypesEnum {
    LINE_COLOR,
    LINE_WIDTH,
    LINE_STYLE,
    STROKE_WIDTH,
    ARROW_TYPE,
    FILL_COLOR,
    OPACITY,
    TEXT_COLOR,
    FONT_FAMILY
}

export enum ChartAnnotationIndicatorTypesEnum {
    AVERAGE = 'AVERAGE',
    TREND = 'TREND'
}
